import axios from 'axios'

export default {
  namespaced: true,

  state: () => ({
    placements: [],
    loading: false,
    search: '',
    page: 1,
    limit: 10,
    totalPages: 1,
  }),

  getters: {
    placements: state => state.placements,
    loading: state => state.loading,
    search: state => state.search,
    page: state => state.page,
    limit: state => state.limit,
    totalPages: state => state.totalPages,
  },

  mutations: {
    SET_PLACEMENTS(state, placements) {
      state.placements = placements
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_SEARCH(state, search) {
      state.search = search
    },
    SET_PAGE(state, page) {
      state.page = page
    },
    SET_TOTAL_PAGES(state, total) {
      state.totalPages = total
    },
    ADD_PLACEMENT(state, placement) {
      state.placements.unshift(placement)
    },
    DELETE_PLACEMENT(state, id) {
      state.placements = state.placements.filter(p => p.id !== id)
    },
    UPDATE_PLACEMENT(state, updated) {
      const index = state.placements.findIndex(p => p.id === updated.id)
      if (index !== -1) state.placements.splice(index, 1, updated)
    },
  },

  actions: {
    async fetchPlacements({ commit, state }) {
      try {
        commit('SET_LOADING', true)

        const { data } = await axios.get('/api/placements', {
          params: {
            search: state.search,
            page: state.page,
            limit: state.limit,
          },
        })

        commit('SET_PLACEMENTS', data.data)
        commit('SET_TOTAL_PAGES', data.last_page)
      } catch (e) {
        console.error('Error fetching placements:', e)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createPlacement({ commit }, payload) {
      try {
        const { data } = await axios.post('/banner/0/group/store_ajax', payload)
        console.log(data)
        commit('ADD_PLACEMENT', data)
        return data
      } catch (e) {
        console.error('Error creating placement:', e)
        throw e
      }
    },

    async updatePlacement({ commit }, payload) {
      try {
        const { data } = await axios.put(`/api/placements/${payload.id}`, payload)
        commit('UPDATE_PLACEMENT', data)
        return data
      } catch (e) {
        console.error('Error updating placement:', e)
        throw e
      }
    },

    async deletePlacement({ commit }, id) {
      try {
        await axios.delete(`/api/placements/${id}`)
        commit('DELETE_PLACEMENT', id)
      } catch (e) {
        console.error('Error deleting placement:', e)
        throw e
      }
    },
  },
}
